import { z } from 'zod';

import { CompanyAchAccountId } from '../BrandedIds';

export const CompanyAchAccount = z.object({
  id: CompanyAchAccountId,
  nickname: z.string(),
  lastFour: z.string(),
  bankName: z.string(),
  isActive: z.boolean(),
  createdAt: z.date(),
});
export type CompanyAchAccount = z.infer<typeof CompanyAchAccount>;
